// Dedupe requests helper
interface CacheEntry<T> {
  promise: Promise<T>;
  expiresAt: number;
}

const inFlightCache = new Map<string, CacheEntry<unknown>>();

export const stableRequestKey = (value: Record<string, unknown>): string => {
  const sortedEntries = Object.keys(value)
    .sort()
    .map((key) => [key, value[key]] as const);

  return JSON.stringify(sortedEntries);
};

export const dedupeRequest = <T>(
  key: string,
  factory: () => Promise<T>,
  ttlMs = 2000
): Promise<T> => {
  const now = Date.now();
  const existing = inFlightCache.get(key) as CacheEntry<T> | undefined;

  if (existing && existing.expiresAt > now) {
    return existing.promise;
  }

  const promise = factory();
  inFlightCache.set(key, { promise, expiresAt: now + ttlMs });

  // Clean up cache on failure to prevent stale entries
  promise.catch(() => {
    const current = inFlightCache.get(key);
    if (current && current.promise === promise) {
      inFlightCache.delete(key);
    }
  });

  return promise;
};
